const SARDINE_ON_HOLD_CONSTANTS = {
  GETTING_SARDINE_ON_HOLD_ORDERS: 'GETTING_SARDINE_ON_HOLD_ORDERS',
  GET_SARDINE_ON_HOLD_ORDERS_SUCCESS: 'GET_SARDINE_ON_HOLD_ORDERS_SUCCESS',
  GET_SARDINE_ON_HOLD_ORDERS_FAILURE: 'GET_SARDINE_ON_HOLD_ORDERS_FAILURE',
  CLEAR_SARDINE_ON_HOLD_ORDERS: 'CLEAR_SARDINE_ON_HOLD_ORDERS'
};

export default SARDINE_ON_HOLD_CONSTANTS;
